import React from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { MAX_DATE_RANGE_DAYS } from "helpers/dictionary";
import { setReportInvoicesGroupedFilters, getReportInvoicesGroupedAction } from "redux/actions/Reports/reportInvoicesGrouped/reportInvoicesGroupedActions";
import { reportInvoicesGroupedLoadings } from "redux/reducers/Reports/reportInvoicesGrouped/types";
import { useSearch } from "hooks/useSearch";

const { GET_REPORT } = reportInvoicesGroupedLoadings;

export const ReportInvoicesGroupedView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(state => state.reportInvoicesGrouped);

  const handleSubmit = (e, isPdf = true) => {
    e.preventDefault();
    if (!station?.length) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, MAX_DATE_RANGE_DAYS, setSnackbar)) return;
    dispatch(getReportInvoicesGroupedAction({ startDate, endDate, stations: station, isPdf }));
  };

  return (
    <GlobalBox title="Reporte Agrupado Listado de Facturación" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportInvoicesGrouped"
        dates
        stations
        multiStations
        maxDate={newDate()}
        dispatchAction={setReportInvoicesGroupedFilters}
        submitAction={handleSubmit}
        submitSecond={(e) => handleSubmit(e, false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.[GET_REPORT]}
      />
    </GlobalBox>
  );
};
